import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import {RouterModule, Routes} from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import {HttpInterceptorProviders} from './http-interceptors';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {IonicStorageModule} from '@ionic/storage';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CookieService} from 'ngx-cookie-service';
import {AuthenticationService} from './http-interceptors/authentication.service';
import {TokenInterceptor} from './http-interceptors/token.interceptor';

import { Camera } from '@ionic-native/camera/ngx';
import { Device } from '@ionic-native/device/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { NgZorroAntdMobileModule, LOCAL_PROVIDER_TOKEN, en_US } from 'ng-zorro-antd-mobile';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
// import { JPush } from '@jiguang-ionic/jpush/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import {FileTransfer} from '@ionic-native/file-transfer/ngx';
// import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { Network } from '@ionic-native/network/ngx';



import {NgxEchartsModule} from 'ngx-echarts';

import {ChangTabService} from './services/chang-tab.service';

import {SharedModule} from './shared.module';
import {ComponentsModule} from './components/components.module';

import {AuthGuard} from './http-interceptors/auth.guard';


export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NgZorroAntdMobileModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateHttpLoader),
        deps: [HttpClient]
      }
    }),
    NgxEchartsModule,
    SharedModule,
    ComponentsModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Base64,
    WebView,
    // ImagePicker,
    Network,
    HttpInterceptorProviders,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    CookieService,
    AuthenticationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    Camera,
    FileTransfer,
    Device,
    ScreenOrientation,
    { provide: LOCAL_PROVIDER_TOKEN, useValue: en_US },
    // JPush,
    ChangTabService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
